import React, {useState} from 'react';
import styled from 'styled-components';
import {AccentColorOptions, AccentColorProps} from 'epic-ue-theme/src/types/colors.types';
import {EpicSearchFilter} from '../../../types/search.types';

const Styled = styled.div<{accentColor?: AccentColorOptions}>`
    .ue-filter-tab {
        text-transform: UPPERCASE;
        font-size: 13px;
        margin-right: 30px;
        font-weight: 500;
        letter-spacing: 2px;
        cursor: pointer;
        padding-bottom: 15px;
        display: inline-block;

        //cover gap between selected border and regular border bottom
        position: relative;
        top: 1px;

        &:focus:not(:focus-visible) {
            outline: 0;
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        &.selected {
            ${(p) =>
                p.accentColor
                    ? `border-bottom: 4px solid ${p.theme.palette.accent[p.accentColor]}`
                    : ''};
        }
    }

    border-bottom: 1px solid ${(p) => p.theme.palette.neutral.steel};

    overflow-x: auto;
    overflow-y: hidden;
`;


const FilterTabsWrap = styled.div`
    text-align: left;
    width: max-content;
    display: inline-block;
`;

export interface FilterTabsProps extends AccentColorProps {
    tabsList?: EpicSearchFilter[];
    selected?: string;
    updateFilterRoute: (...args: any[]) => void;
}

export const FilterTabs = ({
    accentColor = 'sky',
    tabsList,
    selected = 'ALL',
    updateFilterRoute
}: FilterTabsProps): JSX.Element => {
    const [selectedTab, setSelectedTab] = useState(selected);

    return (
        <Styled accentColor={accentColor}>
            <FilterTabsWrap>
            {tabsList?.map((tab, i) => {
                return (
                    <div
                        key={tab.filterName}
                        role="button"
                        tabIndex={i}
                        className={`ue-filter-tab ${
                            selectedTab.toUpperCase() === tab.filterName.toUpperCase()
                                ? 'selected'
                                : ''
                        }`}
                        onClick={(e) => {
                            setSelectedTab(tab.filterName);
                            updateFilterRoute(e, tab.filterName);
                        }}>
                        {tab.filterName}
                    </div>
                );
            })}
            </FilterTabsWrap>
        </Styled>
    );
};
